import { Injectable } from '@angular/core';
import { TokenService } from './token.service';
import { ReplaySubject, Observable } from 'rxjs';
import { BearerToken } from '../models/bearer.token';
import { ApiService } from '.';
import { map } from 'rxjs/operators';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import {
  IApiResponse,
  IChangePasswordDto,
  ICustomerLoginDto,
  IForgotPasswordDto,
  ILoginDto,
  IUserDto,
} from '../models';
import { KeyValue } from '@angular/common';
@Injectable()
export class AuthService {
  // private readonly userKey: string = CommonConstants.authorizationKey;

  private isLoggedInSubject = new ReplaySubject<boolean>(1);
  public isLoggedIn = this.isLoggedInSubject.asObservable();

  constructor(
    private readonly tokenService: TokenService,
    private readonly apiService: ApiService,
    private readonly http: HttpClient
  ) {}

  public onAppLoad() {
    const token = this.tokenService.getToken();

    if (token) {
      this.isLoggedInSubject.next(true);
    } else {
      this.isLoggedInSubject.next(false);
    }
  }

  public setLoggedIn(value: boolean): void {
    this.isLoggedInSubject.next(value);
  }

  public register(model: IUserDto): Observable<IApiResponse<boolean>> {
    return this.apiService.post(`account`, model);
  }

  public updateUser(model: IUserDto) {
    let token = this.tokenService.getToken();
    token.fullName = model.name;
    token.mobile = model.mobile;
    this.tokenService.setToken(token, false);
    this.setLoggedIn(true);
  }

  public changePassword(
    model: IChangePasswordDto
  ): Observable<IApiResponse<boolean>> {
    return this.apiService.post(`account/changePassword`, model);
  }

  public forgotPassword(
    model: IForgotPasswordDto
  ): Observable<IApiResponse<boolean>> {
    return this.apiService.post(`account/forgotPassword`, model);
  }

  public login(credentials: ILoginDto): any {
    const url =
      environment.api_url.substring(
        0,
        environment.api_url.lastIndexOf('/api')
      ) + '/token';

    var data =
      'userName=' +
      credentials.username +
      '&password=' +
      credentials.password +
      '&grant_type=password';
    var reqHeader = new HttpHeaders({
      'Content-Type': 'application/x-www-urlencoded',
      'No-Auth': 'True',
      ClientId: credentials.restaurantId,
      RoleId: credentials.roleId,
      OtpLogin: credentials.otpLogin
    });
    return this.http.post(url, data, { headers: reqHeader }).pipe(
      map((data) => {
        const token = new BearerToken(data);
        this.tokenService.setToken(token, false);
        this.setLoggedIn(true);
        return data;
      })
    );
  }

  public refreshToken(token: BearerToken): any {
    const url =
      environment.api_url.substring(
        0,
        environment.api_url.lastIndexOf('/api')
      ) + '/token';

    var data =
      'refresh_token=' + token.refresh_token + '&grant_type=refresh_token';
    var reqHeader = new HttpHeaders({
      'Content-Type': 'application/x-www-urlencoded',
      'No-Auth': 'True',
    });
    return this.http.post(url, data, { headers: reqHeader }).pipe(
      map((data) => {
        const token = new BearerToken(data);
        this.tokenService.setToken(token, false);
        return data;
      })
    );
  }

  // For Logged In Users
  public deleteAccount(
    model: KeyValue<string, string>
  ): Observable<IApiResponse<boolean>> {
    return this.apiService.post(`account/deactivate`, model);
  }

  // For Public with Email Deactivation Link
  public deactivateAccount(
    model: KeyValue<number, string>
  ): Observable<IApiResponse<boolean>> {
    return this.apiService.put(`account/deactivate`, model);
  }

  public validateCustomerLogin(
    model: ICustomerLoginDto
  ): Observable<IApiResponse<ICustomerLoginDto>> {
    return this.apiService.post(`account/customerLogin`, model);
  }

  public logOut() {
    this.tokenService.removeToken();
    this.setLoggedIn(false);
  }
}
